export default __webpack_public_path__ + "415d2259ead8585b051e56f4d10b3eef.png";